import React, { MouseEvent, Dispatch, useCallback, useState, ReactNode, useEffect } from 'react';
import '../../App.css';
import { IInjectInfo, IHotwash, IGameStatus, IPlayer, IMove } from '../../interfaces';
import { HostSelection } from '../../Classes1';
import Modal from 'react-modal';
import { useAppDispatch } from '../../app/hooks'
import { updateHotwashSelection } from '../../features/hotwash/hotwashSlice'
import { shortRank } from '../rankMap';

interface InjectProps {
    isSelected: string;
    id: string;
    setInjectItem: Dispatch<any>;
    setZoomLevel: Dispatch<any>;
    zoomLevel: number;
    turn: number;
    isHost: boolean;
    hotwashInjects: IInjectInfo[];
    hotwashStatus: IHotwash;
    y: string;
    injectItem: IInjectInfo;
    currentGame: IGameStatus;
    updateHotwashStatus: Dispatch<any>;
    openInject: boolean;
    setOpenInject: Dispatch<any>;
    selectedPlayer: IPlayer;
    setSelectedPlayer: Dispatch<any>;
  }

  export interface Item {
    id: number
    text: string
  }

  export interface coaArr {
    id: number
    text: string
  }

  Modal.setAppElement('#root');

  const customStyles = {
    content: {
      background: '#323544',
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      padding: '16px',
      border: 'none',
      width: '808px',
      height: '636px',
      transform: 'translate(-50%, -50%)',
    }
  };

const RGLHotwashInject: React.FC<InjectProps> = ({ isSelected, id, setInjectItem, setZoomLevel, zoomLevel, turn, hotwashInjects, hotwashStatus, injectItem, currentGame, isHost, updateHotwashStatus, openInject, setOpenInject, setSelectedPlayer, selectedPlayer }) => {

  const [injectModalIsOpen, setInjectModalIsOpen] = useState<boolean>(false);

  let dispatch = useAppDispatch()

  useEffect(() => {
    if (openInject) {
      if (!injectModalIsOpen && id === injectItem.injectId) {
        openInjectModal()
      }
    }
  }, [openInject]); // eslint-disable-line react-hooks/exhaustive-deps

  const closeInjectModal = () => {
    setOpenInject(false)
    setInjectModalIsOpen(false);
  }

  const openInjectModal = () => {
    setInjectModalIsOpen(true);
  }

    hotwashInjects.forEach((inject) => {
      let hasTurns: number[] = [];
      
      if (inject.id.toString() === id) {
        for (let i = 0; i<inject.nodes.length; i++) {
          hasTurns.push(inject.nodes[i].turn);
        }
      }
    })

    const showPlayer = useCallback((userID: string | undefined) => {
      currentGame.players.forEach((player: IPlayer, i: number) => {
          if (player.userID === userID) {
              setSelectedPlayer(player);
          }
      });
  }, [currentGame.players]) // eslint-disable-line react-hooks/exhaustive-deps

    const selectPlayer = async (ev: MouseEvent) => {
      
      ev.stopPropagation();

      if (isHost) {
          const target = ev.currentTarget as HTMLElement;
          if (target) {
              let newHostSelection: any = {};
              newHostSelection.hotwashId = hotwashStatus.gameId;
              newHostSelection.hostSelection = new HostSelection();
              
              newHostSelection.hostSelection.page = '';
              newHostSelection.hostSelection.turn = hotwashStatus.currentSelection ? hotwashStatus.currentSelection.turn : '';
              newHostSelection.hostSelection.inject = hotwashStatus.currentSelection ? hotwashStatus.currentSelection.inject : '';
              newHostSelection.hostSelection.node = id;
              newHostSelection.hostSelection.nodeTab = '';
              newHostSelection.hostSelection.nodePlayerID = target.dataset.id;
              
              await dispatch(updateHotwashSelection(newHostSelection))
              updateHotwashStatus(hotwashStatus.gameId)

              showPlayer(target.dataset.id);
          }
      }
  }

    const unplayedInject = (injectId: string) => {
      let unplayed: string = 'unplayed';

      currentGame.mainGroup.moveHistory.forEach((move: IMove) => {
        if (move.type === 'result' && move.options === null && move.injectId === injectId && move.turn === hotwashStatus.currentSelection.turn) {
          unplayed = '';
        }
      })
      return unplayed;
    }

    const getGroupLabel = (): ReactNode | null => {

      const zoom5width = 90;
      const zoomWidth = 303;
      const zoom5padding = 184;
      const zoomPadding = 283;
      const zoomWidth1 = 228;
      const teamLeftPx = 216;

      if (hotwashStatus.currentSelection !== null) {
        return hotwashInjects.map((item, i) => {
          if (item.injectId.toString() === id) {
            
            let leftPx: number = 0;
            if (item.startTurn + item.turnLength - 1 >= hotwashStatus.currentSelection.turn && item.startTurn <= hotwashStatus.currentSelection.turn) {
              if (item.startTurn < hotwashStatus.currentSelection.turn) {
                if (zoomLevel === 5) {
                  leftPx = (zoom5width * (hotwashStatus.currentSelection.turn - item.startTurn) + zoom5padding)
                } else {
                  leftPx = (zoomWidth * (hotwashStatus.currentSelection.turn - item.startTurn)) + zoomPadding
                  if (hotwashStatus.currentSelection.turn - item.startTurn > 1) {
                    leftPx += (hotwashStatus.currentSelection.turn - item.startTurn) * 33
                  }
                }
              }
              if (item.startTurn === hotwashStatus.currentSelection.turn) {
                if (zoomLevel === 5) {
                  leftPx = zoom5width;
                } else {
                  leftPx = zoomWidth1;
                }
              }
              return <div className={`inject-main-team`} style={{ left: leftPx }} key={i}><img src="img/small-team.svg" className="main-team-icon" alt="team" />Main Team</div>
            }
            if (item.startTurn === hotwashStatus.currentSelection.turn) {
              leftPx = teamLeftPx;
              return <div className={`inject-main-team`} style={{ left: leftPx }} key={i}><img src="img/small-team.svg" className="main-team-icon" alt="team" />Main Team</div>
            } else {
              return <div key={i}></div>
            }
          } else {
              return <div key={i}></div>;
          }
        })
      } else {
        return <></>
      }
    }

    const getGroupLine = (): ReactNode | null => {
      let turnLength: number = 0;
      if (zoomLevel === 5) {
        turnLength = 178;
      } else {
        turnLength = 352;
      }
      if (hotwashStatus.currentSelection !== null) {
        return hotwashInjects.map((item, i) => {
          if (item.injectId.toString() === id) {
            let barArr: any[] = [];
            
            if (item.startTurn + item.turnLength - 1 >= hotwashStatus.currentSelection.turn) {
              for (let j = 0; j<item.turnLength; j++) {
                if (zoomLevel === 5) {
                  barArr.push(<img src="img/inject-main-group.svg" className="inject-main-group" style={{ width: j>0 ? turnLength+8 : turnLength +'px'}} alt="label" key={i+j} />)
                } else {
                  barArr.push(<img src="img/inject-main-group.svg" className="inject-main-group" style={{ width: turnLength + 'px'}} alt="label" key={i+j} />)
                }
              }
              return barArr;
            }
            if (item.startTurn === hotwashStatus.currentSelection.turn) {
              return <img src="img/inject-main-group.svg" className="inject-main-group" style={{ width: turnLength+'px'}} alt="label" key={i} />
            } else {
              return <div key={i}></div>
            }
          } else {
              return <div key={i}></div>;
          }
        })
      }
    }

    return (
      hotwashInjects.map((item, i) => {
        if (item.injectId.toString() === id.toString()) {
            return (
                <div className={`inject rgl-inject rgl-hotwash-inject ${isSelected} ${unplayedInject(item.injectId)}`} data-id={id.toString()} key={item.id}>
                  <div className="inject-content">
                    <div className="inject-exclaim">
                      <img src="img/inject-exclaim.svg" className="inject-exclaim-svg" alt="" draggable={false}/>
                    </div>
                    
                    <div className="inject-text">
                      <div className="inject-title">{item.name}</div>
                      
                      <div className="inject-detail">{item.turnLength} Turn, Starts Turn {item.startTurn}</div>
                    </div>
                  </div>
                  <img className="inject-more-detail" src="img/gray-ellipsis.svg" alt="detail" data-id={item.id.toString()} />
                  {unplayedInject(item.injectId) === '' ? getGroupLine() : ''}
                  {unplayedInject(item.injectId) === '' ? getGroupLabel() : ''}
                  <Modal
                    isOpen={injectModalIsOpen}
                    onRequestClose={closeInjectModal}
                    style={customStyles}
                    contentLabel="Node Detail Modal"
                >
                  <div className="node-modal-small-title">Inject Node</div>
                  <div className="node-modal-title">{injectItem.name}</div>
                  
                        <div className="node-modal-tab-left">
                                <div className="node-modal-team-label">Team Members</div>
                                <div className="node-modal-team-content">
                                    {currentGame.players.map((player: IPlayer, i: number) => {
                                        return <div className={`node-modal-team-member ${player.userID === selectedPlayer.userID ? 'selected' : ''}`} data-id={player.userID} onClick={selectPlayer} key={i}>
                                            <div className="member-name-title">
                                                <div className="member-title">{shortRank(player.rank)}</div>
                                                <div className="member-lastname">{player.lastName}</div>
                                            </div>
                                            <div className="member-role">
                                                {player.role}
                                            </div>
                                        </div>
                                    })}
                            </div>
                        </div>
                        <div className="node-modal-tab-right">
                                <div className={`inject-modal-tab-content`}>
                                    <div className="node-modal-intent">
                                        <div className="node-modal-intent-title">Intent</div>
                                        {currentGame.mainGroup.moveHistory.map((move: any, i: number) => {
                                          
                                            if (move.player === selectedPlayer.userID && move.choice === injectItem.id.toString() && move.type === 'inject' && move.turn === turn) {
                                                return (<div className="node-modal-intent-content" key={i}>
                                                        {move.comment}
                                                    <div className="node-modal-intent-sig"> - {move.player}</div>
                                                </div>)
                                            } else {
                                                return <div key={i}></div>
                                            }
                                    
                                        })}
                                        
                                    </div>
                                    <div className="node-modal-coa-coas">
                                        <div className="node-modal-coa-coas-title">Injects</div>
                                        <div className="node-modal-coa-coas-content">
                                        {hotwashInjects.map((inject: IInjectInfo, i: number) => {
                                          if (injectItem.injectId === inject.injectId) {
                                              return (currentGame.mainGroup.moveHistory.map((move: any, j: number) => {
                                                    if (move.player === selectedPlayer.userID && move.injectId === injectItem.injectId && move.type === 'inject' && move.turn === turn) {
                                                        return <div className="node-modal-coas-item" key={i+j}>
                                                            <div className="node-modal-coas-vote checked">
                                                                <img src="img/green-check-shadow.svg" alt="check"  className="vote-checked"></img>
                                                            </div>
                                                            <div className="node-modal-coas-vote-desc">{inject.name}</div>
                                                            <div className="node-modal-coas-vote-count"> Votes</div>
                                                        </div>
                                                    } else {
                                                        return <div key={i+j}></div>
                                                    }
                                              }))
                                          } else {
                                            return <div key={i}></div>
                                        }
                                        })}

                                        {hotwashInjects.map((inject: IInjectInfo, i: number) => {
                                          if (injectItem.injectId === inject.injectId) {
                                            return (inject.moveHistory.map((move: any, j: number) => {
                                                    if (move.player === selectedPlayer.userID && move.type === 'inject' && move.choice !== inject.injectId) {
                                                        return <div className="node-modal-coas-item" key={i+j}>
                                                            <div className="node-modal-coas-vote"></div>
                                                            <div className="node-modal-coas-vote-desc">{inject.name}</div>
                                                            <div className="node-modal-coas-vote-count"> Votes</div>
                                                        </div>
                                                    } else {
                                                        return <div key={i+j}></div>
                                                    }
                                              }))
                                          } else {
                                            return <div key={i}></div>
                                        }
                                        })}
                                            
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                            <div className="node-modal-done-button" onClick={closeInjectModal}>Done</div>
                </Modal>
              </div>
            )
            
          } else {
            return <div key={item.id}></div>
          }
      })
    )
}

export default RGLHotwashInject;